<template>
  <q-btn
    class="bg-white no-padding"
    style="margin: 1rem auto;"
    @click="handleClick"
  >
    <div class="text-weight-bold" style="font-size: medium; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 1.5rem;">
      <p>{{  time }}</p>
      <p>{{  year }}</p>
    </div>
  </q-btn>
</template>

<script>
  export default {
    props: {
      time: {
        type: String,
        required: true
      },
      year: {
        type: Number,
        required: true
      },
      index: {
        type: Number,
        required: true
      }
    },
    methods: {
      handleClick () {
        this.$emit('cardClick', this.index)
      }
    }
  }
</script>
